const EMPTY_RUN_IDS: string[] = [];
const EMPTY_EXPERIMENT_NAMES: string[] = [];

interface FilterParams {
  runIds: string[];
  experimentNames: string[];
  experimentsOnlyMode?: boolean;
  sourceOfTruth?: {
    runIds?: string[] | Set<string>;
    experimentNames?: string[] | Set<string>;
  };
}

export function experimentsOnlyModeGuard({
  runIds,
  experimentNames,
  sourceOfTruth,
  experimentsOnlyMode,
}: FilterParams) {
  return {
    runIds: experimentsOnlyMode
      ? EMPTY_RUN_IDS
      : filterSelectedEntities(runIds, sourceOfTruth?.runIds),
    experimentNames: experimentsOnlyMode
      ? filterSelectedEntities(experimentNames, sourceOfTruth?.experimentNames)
      : EMPTY_EXPERIMENT_NAMES,
  };
}

export function filterSelectedEntities(input: string[], sourceOfTruth?: string[] | Set<string>) {
  if (!sourceOfTruth) {
    return input;
  }

  if (sourceOfTruth instanceof Set) {
    return input.filter((id) => sourceOfTruth.has(id));
  }

  return input.filter((id) => sourceOfTruth.includes(id));
}
